'use client';

import React from 'react';

interface FilterChipsProps {
  selectedFilters: string[];
  onFilterToggle: (filter: string) => void;
  filterCounts: Record<string, number>;
}

const FilterChips: React.FC<FilterChipsProps> = ({
  selectedFilters,
  onFilterToggle,
  filterCounts,
}) => {
  const scentTypes = ['Floral', 'Woody', 'Fresh', 'Oriental'];

  return (
    <div data-component-id="src/app/shop-catalog/components/FilterChips.tsx:19:4" data-component-path="src/app/shop-catalog/components/FilterChips.tsx" data-component-line="19" data-component-end-line="41" data-component-file="FilterChips.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-3%22%7D" className="flex flex-wrap gap-3">
      {scentTypes.map((scent) => {
        const isSelected = selectedFilters.includes(scent);
        const count = filterCounts[scent] || 0;

        return (
          <button data-component-id="src/app/shop-catalog/components/FilterChips.tsx:25:10" data-component-path="src/app/shop-catalog/components/FilterChips.tsx" data-component-line="25" data-component-end-line="38" data-component-file="FilterChips.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            key={scent}
            onClick={() => onFilterToggle(scent)}
            disabled={count === 0 && !isSelected}
            className={`rounded-full px-5 py-2.5 font-body text-sm font-medium transition-luxury disabled:cursor-not-allowed disabled:opacity-40 ${
              isSelected
                ? 'bg-primary text-primary-foreground shadow-luxury-sm'
                : 'bg-muted text-text-secondary hover:bg-secondary hover:text-secondary-foreground'
            }`}
            aria-pressed={isSelected}
          >
            {scent}
            <span data-component-id="src/app/shop-catalog/components/FilterChips.tsx:37:12" data-component-path="src/app/shop-catalog/components/FilterChips.tsx" data-component-line="37" data-component-end-line="37" data-component-file="FilterChips.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22ml-2%20font-data%20text-xs%20opacity-75%22%2C%22textContent%22%3A%22(%20)%22%7D" className="ml-2 font-data text-xs opacity-75">({count})</span>
          </button>
        );
      })}
    </div>
  );
};

export default FilterChips;